/**
 * "Playground" — Dashboard section (ADR-0074).
 * Reconciled from apps/web playground feature (route /playground): the real
 * widget wired to a live conversation against the active environment's catalog.
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_PLAYGROUND_PAGE: DocPageContent = {
  slug: 'dashboard/playground',
  titleKey: 'docs.dashboard.playground.title',
  descriptionKey: 'docs.dashboard.playground.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.playground.lead' },

    { kind: 'heading', level: 2, id: 'what', textKey: 'docs.dashboard.playground.what.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.playground.what.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'controls',
      textKey: 'docs.dashboard.playground.controls.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.playground.controls.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.playground.controls.item.design',
        'docs.dashboard.playground.controls.item.size',
        'docs.dashboard.playground.controls.item.scheme',
        'docs.dashboard.playground.controls.item.environment',
      ],
    },

    { kind: 'heading', level: 2, id: 'data', textKey: 'docs.dashboard.playground.data.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.playground.data.body' },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.dashboard.playground.meter.title',
      textKey: 'docs.dashboard.playground.meter.body',
      links: {
        limits: {
          target: { docSlug: 'billing/limits' },
          labelKey: 'docs.dashboard.playground.meter.link',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.playground.next.catalog.title',
          textKey: 'docs.dashboard.playground.next.catalog.text',
          to: { docSlug: 'dashboard/catalog' },
        },
        {
          titleKey: 'docs.dashboard.playground.next.widget.title',
          textKey: 'docs.dashboard.playground.next.widget.text',
          to: { docSlug: 'widget' },
        },
      ],
    },
  ],
};
